import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsAppliancesCameraCounts extends SnModel {
  @Expose()
  public countExternalCameras: number;

  @Expose()
  public countManagedCameras: number;

  @Expose()
  public countTotalCameras: number;

  @Expose()
  public countUnconfiguredCameras: number;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
